import VSelectCardChargeType from './index.vue';

export default {
  install: (Vue) => Vue.component('VSelectCardChargeType', VSelectCardChargeType),
};
